/** @jsxImportSource @emotion/react */

import { FC, useMemo } from "react";
import DetailsSection from "../../../../../../components/Details/components/Main/Section/DetailsSection";
import SentQuotationsTable from "../../../components/SentQuotationsTable";
import Row from "../../../../../../components/Grid/Row";
import Column from "../../../../../../components/Grid/Column";
import Typography from "../../../../../../components/Typography";
import useDocumentDetails from "../../../../../../hooks/useDocumentDetails";
import TextAreaInput from "../../../../../../components/Input/TextAreaInput";
import {
  DocumentStages,
  DocumentStatus,
  Result,
} from "../../../../../../graphql/__GENERATED__/types";
import { useUIStore } from "../../../../../../hooks/useUIStore";

const SelectedQuotations: FC = () => {
  const {
    orderedResults,
    quotationComment,
    setQuotationComment,
    documentData: {
      selectedSimulationResults,
      justificationMessage,
      status,
      stage,
    },
  } = useDocumentDetails();

  const { documentColor } = useUIStore();

  const { quotationDone, quotationPending } = useMemo(() => {
    const quotationDone =
      DocumentStages.Simulation && status === DocumentStatus.Done;
    const quotationPending =
      DocumentStages.Simulation && status === DocumentStatus.Pending;
    return { quotationDone, quotationPending };
  }, [stage, status]);

  const sectionTitle = useMemo(
    () => (quotationDone ? "Cotações selecionadas" : "Cotações salvas"),
    [quotationDone]
  );

  const handleInputComments = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setQuotationComment(e.target.value);
  };

  const shouldRenderTable = useMemo(() => {
    return orderedResults.length > 0;
  }, [orderedResults.length]);

  const { isDrawerFullWidth } = useUIStore();

  return (
    <>
      {shouldRenderTable && (
        <DetailsSection title={sectionTitle} subtitle>
          <>
            <Row>
              <Column xs={12} xl={isDrawerFullWidth ? 8 : 12}>
                <SentQuotationsTable
                  results={
                    quotationDone
                      ? orderedResults
                      : (selectedSimulationResults as Result[])
                  }
                />
              </Column>
            </Row>
            {!quotationPending && !quotationDone && (
              <Row>
                <Column xs={12}>
                  <Typography
                    variant="textMedium"
                    align="left"
                    component="div"
                    color={documentColor}
                    uppercase
                  >
                    comentário sobre a cotação:
                  </Typography>
                  <Typography
                    variant="textMedium"
                    align="left"
                    component="div"
                    margin="sm"
                  >
                    {justificationMessage || "Não foi adicionado comentário."}
                  </Typography>
                </Column>
              </Row>
            )}
            {quotationDone && (
              <Row>
                <Column xs={12}>
                  <TextAreaInput
                    name="observations"
                    value={quotationComment}
                    onChange={handleInputComments}
                    placeholder="Deixe seus comentários aqui..."
                    disabled={!true}
                  />
                </Column>
              </Row>
            )}
          </>
        </DetailsSection>
      )}
    </>
  );
};

export default SelectedQuotations;
